import {Component} from "@angular/core";

@Component({
    selector: "fhm-signup-page",
    styleUrls: ["./signup-page.component.scss"],
    templateUrl: "./signup-page.component.html",
    standalone: false
})
export class SignupPageComponent {

    constructor() {
    }

}
